import React from 'react';
import PropTypes from 'prop-types';

export default class BlockSection extends React.Component {
  static propTypes = {
    padding: PropTypes.string,
    topLevel: PropTypes.bool,
    open: PropTypes.bool,
    showDivider: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open ? true : false,
      className: this.props.open ? 'section open' : 'section',
    };

    // if (this.props.open) {
    //   this.setOpenState();
    // }

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    if(this.state.open) {
      this.setCloseState();
    }else{
      this.setOpenState();
    }
  }

  setCloseState() {
    this.setState({
      open: false,
      className: 'section'
    });
  }

  setOpenState() {
    this.setState({
      open: true,
      className: 'section open'
    });
  }

  render() {
    const { padding, topLevel, showDivider } = this.props;
    const { open, className } = this.state;

    const arrowStyle = (!open) ? styles.grayArrowDown : styles.grayArrowUp;
    const rectangleWidth = '185px';

    return (
      <div 
      // className={className} 
      // style={ { padding: `0 0 0 ${padding}`,  cursor: 'pointer'} }
      >
        <div className='flex-row' style={ styles.showAllData } onClick={this.handleClick}>
          {this.props.title}
          <i
            style={ arrowStyle }
          />
          {/* {topLevel && <i style={ { ...styles.showAllRectangle, width: rectangleWidth } } />} */}
        </div>
        {open ? <div className="articlewrap">
          <div className="article">
            {this.props.children}
          </div>
        </div>:null}
        {/* { open && showDivider ? (
          <div className="divider" />
        ) : null} */}
      </div>
    );
  }
}

const styles = {
  showAllData: {
    padding: '16px 24px',
    width: '100%',
    color: 'rgb(181, 181, 181)',
    fontSize: 12,
    fontWeight: 600,
    fontSize: 14,
    fontWeight: 600,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  grayArrowDown: {
    height: '6px',
    width: '10px',
    cursor: 'pointer',
    display: 'inline-block',
    backgroundImage: 'url(images/arrow_down.svg)',
    backgroundRepeat: 'no-repeat',
    margin: '0 0 1px 5px',
  },
  grayArrowUp: {
    height: '6px',
    width: '10px',
    cursor: 'pointer',
    display: 'inline-block',
    backgroundImage: 'url(images/arrow_up.svg)',
    backgroundRepeat: 'no-repeat',
    margin: '0 0 1px 5px',
  },
  showAllRectangle: {
    height: '1px',
    backgroundColor: '#E7E7E7',
    display: 'inline-block',
    margin: '0px 0 4px 10px',
  }
};
